import React, { useState } from "react";
import Logo from "@/components/Logo";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import api, { errText } from "@/lib/api";

export default function Recuperar() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cargando, setCargando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const pedir = async (e) => {
    e.preventDefault();
    setCargando(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setEnviado(true);
    } catch (err) {
      toast.error(errText(err));
    } finally { setCargando(false); }
  };

  const resetear = async (e) => {
    e.preventDefault();
    setCargando(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Listo, ya podés entrar con tu contraseña nueva.");
      nav("/login");
    } catch (err) {
      toast.error(errText(err));
    } finally { setCargando(false); }
  };

  return (
    <div className="min-h-screen bg-negro flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="w-full max-w-md">
        <Logo variant="full" height={120} className="mb-12 mx-auto block" />

        {token ? (
          <>
            <h1 className="titulo text-5xl mb-3">Nueva contraseña.</h1>
            <p className="text-gris mb-10">Elegí una y entrás de nuevo.</p>
            <form onSubmit={resetear} className="space-y-4">
              <input className="input-dark" type="password" placeholder="Tu contraseña nueva" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="reset-password" />
              <button className="btn-dorado w-full mt-2" disabled={cargando} data-testid="reset-submit">{cargando ? "GUARDANDO…" : "GUARDAR"}</button>
            </form>
          </>
        ) : enviado ? (
          <>
            <h1 className="titulo text-5xl mb-3">Fijate el mail.</h1>
            <p className="text-gris mb-10">Si ese mail tiene cuenta, te mandamos un link para elegir una contraseña nueva.</p>
            <Link to="/login" className="btn-fantasma inline-block" data-testid="volver-login">VOLVER</Link>
          </>
        ) : (
          <>
            <h1 className="titulo text-5xl mb-3">¿La olvidaste?</h1>
            <p className="text-gris mb-10">Poné tu mail y te mandamos cómo recuperarla.</p>
            <form onSubmit={pedir} className="space-y-4">
              <input className="input-dark" type="email" placeholder="Tu mail" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
              <button className="btn-dorado w-full mt-2" disabled={cargando} data-testid="forgot-submit">{cargando ? "MANDANDO…" : "MANDAME EL LINK"}</button>
            </form>
            <div className="mt-8 text-sm"><Link to="/login" className="text-gris hover:text-dorado transition-colors">Volver</Link></div>
          </>
        )}
      </motion.div>
    </div>
  );
}
